export const STATUS_NO_ACCESS_MIC = 'noAccessMic';
export const STATUS_NO_ACCESS_CAM = 'noAccessCam';
export const STATUS_NO_ACCESS = 'noAccess';

export const STATUS_CONNECTION_FAILED = 'connectionFailed';
export const STATUS_DISCONNECTED = 'disconnected';
export const STATUS_UNREGISTERED = 'unregistered';
export const STATUS_CONNECTED = 'connected';
export const STATUS_OK = 'ok';
